import { render } from "./LinkageChangeEmailRescueProfile.vue?vue&type=template&id=52711741&ts=true"
import script from "./LinkageChangeEmailRescueProfile.vue?vue&type=script&lang=ts"
export * from "./LinkageChangeEmailRescueProfile.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src1364277118/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__